import { useEffect } from 'react';

// Small helper that sets the document title for a page. On unmount it restores
// the previous title so returning to the public site keeps the default
// "The AdAura Awards 2026" banner from index.html.
const usePageTitle = (title) => {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = `${title} · AdAura Awards 2026`;
    return () => {
      document.title = previous;
    };
  }, [title]);
};

export default usePageTitle;
